<template>
  <div class="card shadow p-2">
    <div class="card-body">
      <div class="d-flex flex-column flex-md-row justify-content-between w-100">
        <div
          class="d-flex flex-column my-auto"
          style="max-width:400px; width: 400px"
        >
          <div class="d-flex mb-2">
            <v-highlight
              :product-id="contract.productId || claim.productId || null"
              :product-name="productName"
            />
          </div>
          <div class="d-flex lead">
            N° {{ claim.reference }}
          </div>
          <div
            v-if="claim.productId === 16"
            class="d-flex mt-2"
          >
            {{ formattedAddress }}
          </div>
          <div
            v-else-if="mainActivity"
            class="d-flex mt-2"
          >
            {{ mainActivity }}
          </div>
        </div>
        <div class="my-auto text-md-center block-min-width">
          Déclaré le {{ formattedDate }}
        </div>
        <div class="my-auto text-center d-none d-md-flex block-min-width">
          <div
            class="badge badge-pill rounded-pill"
            :class="`bg-${formattedStatus.color} text-${formattedStatus.textColor || 'blue-700'}`"
          >
            {{ formattedStatus.text }}
          </div>
        </div>
        <div class="d-flex my-auto">
          <router-link
            v-slot="{ navigate }"
            :to="`/client/claim/${claim.id}`"
            custom
          >
            <button
              type="button"
              class="btn btn-primary my-auto w-100 mt-3 mt-md-0"
              @click="navigate"
              @keypress.enter="navigate"
            >
              <div class="d-flex flex-row">
                <div class="ms-auto me-1">
                  <span class="d-none d-xl-inline">
                    Voir le détail
                  </span>
                  <span class="d-inline d-xl-none">
                    Détail
                  </span>
                </div>
                <v-icon
                  icon="arrow-white-right"
                  class="me-auto"
                />
              </div>
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { has, get } from 'lodash-es';
import { formatDate } from '@/utils/_Date';

import ProductHighlight from '@/components/common/helpers/ProductHighlight.vue';

export default {
  name: 'ClaimDisplay',
  components: {
    'v-highlight': ProductHighlight,
  },
  props: {
    claim: {
      type: Object,
      required: true,
      default: () => ({
        grid: { product: { name: null } },
      }),
    },
    enumValue: {
      type: String,
      default: 'IN_PROGRESS',
    },
  },
  computed: {
    ...mapGetters({
      products: 'rater/products',
      invoices: 'invoices/items',
    }),
    contract() {
      return this.claim.subscription || this.claim.policy || {};
    },
    productName() {
      return (this.products
        .find(({ id }) => id === (this.contract.productId || this.claim.productId))
        || {})
        .name;
    },
    mainActivity() {
      return get(this.contract, 'risk.mainActivity.name', null);
    },
    formattedAddress() {
      if (!has(this.contract, 'risk.local.address')) {
        return '';
      }
      const { address } = this.contract.risk.local;
      return `${address.street}, ${address.city}`;
    },
    formattedStatus() {
      return this.getStatusByEnumValue(this.enumValue);
    },
    formattedDate() {
      return formatDate(this.claim.createdAt);
    },
  },
  methods: {
    getStatusByEnumValue(enumValue) {
      const status = {
        CREATED: {
          text: 'Créé', color: 'blue-400', textColor: 'white',
        },
        IN_PROGRESS: {
          text: 'En cours', color: 'blue-400', textColor: 'white',
        },
        CLOSED: {
          text: 'Traité', color: 'green-300', textColor: 'blue-700',
        },
        DISMISSED: {
          text: 'Sans suite', color: 'gray-500', textColor: 'white',
        },
        WAITING_FOR_PROOF: {
          text: 'En attente de pièces', color: 'yellow-600', textColor: 'blue-700',
        },
        UNDER_REVIEW: {
          text: 'A l\'étude', color: 'blue-400', textColor: 'white',
        },
        CHECKING: {
          text: 'Vérification', color: 'blue-500', textColor: 'white',
        },
        HANDLED: {
          text: 'Pris en charge', color: 'blue-500', textColor: 'white',
        },
        DECLINED: {
          text: 'Refusé', color: 'red-700', textColor: 'white',
        },
      };
      return status[enumValue] || {};
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 576px) {
  .block-min-width {
    max-width:100px;
    width: 100px
  }
}
</style>
